import { Box, Input, OutlinedInput, Popover } from '@mui/material';
import React, { useState } from 'react';
import RoundedInput from '../../../components/RoundedInput';
import MiniCalendar from '../MiniCalendar';

interface CustomDateSelector {
  selectedDate: Date | null;
  setSelectedDate: (day: Date | null) => void;
  minDate: Date | null;
  maxDate: Date | null;
  onDateChange: (date: Date) => void;
}

const CustomDateSelector = ({
  minDate,
  maxDate,
  onDateChange,
  setSelectedDate,
  selectedDate,
}: CustomDateSelector) => {
  const [calendarOpen, setCalendarOpen] = useState<boolean>(false);

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
    onDateChange(date);
    setCalendarOpen(false);
  };

  const handleInputClick = () => {
    setCalendarOpen(true);
  };

  return (
    <>
      <Box position="relative" width="100%">
        <OutlinedInput
          size={'small'}
          placeholder="DD/MM/YYYY"
          value={selectedDate ? selectedDate.toLocaleDateString('en-GB') : ''}
          onClick={handleInputClick}
          readOnly
          fullWidth
          sx={{
            background: '#fff',
            borderRadius: '2rem',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'solid 1px #464e5f',
            },
            '&:hover': {
              borderColor: '#464e5f',
            },
            '&.Mui-focused': {
              borderColor: '#464e5f',
            },
          }}
        />
        {calendarOpen && (
          <Popover
            sx={{
              '& .MuiPaper-root': {
                backgroundColor: '#fafafa',
                padding: '16px',
              },
            }}
            open={calendarOpen}
            anchorEl={document.querySelector('input')}
            onClose={() => setCalendarOpen(false)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}>
            <MiniCalendar
              datePicker={true}
              currentDay={selectedDate || new Date()}
              onDateChange={handleDateChange}
              minDate={minDate || undefined}
              maxDate={maxDate || undefined}
            />
          </Popover>
        )}
      </Box>
    </>
  );
};
export default CustomDateSelector;
